<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Recharge 1H d'appels</div>
</div>
<div class="w-100 pt-3">
    <span>
        Vous avez consommé <strong>{{ consumption.total.voice.consumption }}</strong> sur les <strong>{{ consumption.total.voice.limit }}</strong>. Voulez-vous souscrire à une recharge de 1h d'appels supplémentaires ?
        <br/>
        Cette option vous coûtera <strong>{{ priceDetails?.price }}
        @if (priceDetails?.perMonth) {
            <span>/mois</span>
        }</strong>.
        <br/>
        Elle est sans engagement et vous pourrez l'utiliser uniquement sur le mois en cours.
        <br/>
        Pour plus d'informations, vous pouvez consulter le <a [href]="line.offer.offerGt" target="_blank">Guide Tarifaire de votre forfait</a> (rubrique "Infos et Documents").
    </span>
</div>
<div class="w-100 pt-3 text-center cta_container">
    <button type="button" class="cta_cancel column" (click)="cancel()">Non<span></span></button>
    <button type="button" class="cta_btn level_2 column" (click)="send()">Oui<span></span></button>
</div>
